/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios from 'axios';

export const getSlides = (sectionId: string, userId: string, lessonNodeId: string) => {
  const url = `/api/slides/section/${sectionId}/user/${userId}/lesson/${lessonNodeId}/`;
  return axios.get(url).then((response) => response.data);
};

export const createSlideCopy = (
  sectionId: string,
  userId: string,
  lessonNodeId: string,
) => {
  const url = `/api/slides/section/${sectionId}/user/${userId}/lesson/${lessonNodeId}/`;
  return axios.post(url).then((response) => ({ response }));
};

export const getSlideData = (slideId: string) => {
  const url = `/api/slides/${slideId}/`;
  return axios.get(url).then((response) => response.data);
};

export const saveSlide = (sectionId: string, userId: string, lessonNodeId: string) => {
  const url = `/api/slides/section/${sectionId}/user/${userId}/lesson/${lessonNodeId}/`;
  return axios.patch(url).then((response) => response.data);
};
